import { render } from "./SocialLinks.vue?vue&type=template&id=67bfe7be"
import script from "./SocialLinks.vue?vue&type=script&lang=js"
export * from "./SocialLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__